module.exports = __webpack_public_path__ + "img/teacher.eb4c2594.svg";